const en = {
  nav: {
    home: 'Home',
    services: 'Services',
    destinations: 'Destinations',
    about: 'About',
    contact: 'Contact',
    contactUs: 'Contact Us',
  },
  hero: {
    tagline: 'SAUDI ARABIA, PREMIUM TRAVEL',
    heading: 'Respond to the Sacred Call with a Peaceful Heart',
    subheading: 'Travel with ease, worship with presence, we handle the rest.',
    planJourney: 'Plan Your Journey',
    exploreServices: 'Explore Services',
  },
  about: {
    label: 'ABOUT US',
    heading: 'Your Trusted Partner for Unforgettable Experiences',
    p1: 'Kingdom Group is your trusted partner for unforgettable experiences in Saudi Arabia. From the sacred pilgrimage of Umrah to personalized tours across the Kingdom, we provide end-to-end guidance with the care and attention you deserve.',
    p2: 'With years of experience and deep local knowledge, we ensure every journey is crafted to perfection, respecting your spiritual needs and travel preferences.',
  },
  services: {
    label: 'OUR SERVICES',
    heading: 'Crafted for Your Journey',
    s1Title: 'Umrah Guide',
    s1Desc: 'Your personal guide for a meaningful and spiritually fulfilling Umrah — step by step, by your side. Assistance in Arabic, Russian, and English for individuals and families.',
    s1Price: 'From $400 / person',
    s2Title: 'Individual Tour',
    s2Desc: 'A fully personalized Umrah journey — airport pickup, hotels in Madinah and Makkah, guided Ziyarah, Umrah rituals, all transfers, and departure. Everything arranged, nothing to worry about.',
    s2Price: 'From $1,000 / person',
    s4Title: 'Transfer Service',
    s4Desc: 'Comfortable private transfers across Saudi Arabia — airport pickups, intercity routes, and everything in between. No shared rides, professional drivers, meet & greet included.',
    s4Price: 'From 150 SAR',
    s5Title: '10-Year Saudi Visa',
    s5Desc: 'Exclusive to US passport holders. A decade of unlimited access to Saudi Arabia — Umrah, tourism, and business. Multiple entry, 180 days per visit. We handle everything for $580 all inclusive.',
    s5Price: '$580 · All Inclusive',
  },
  why: {
    label: 'WHY CHOOSE US',
    heading: 'The Kingdom Group Difference',
    items: [
      { title: 'Personalized Service', desc: 'Every journey is tailored to your needs' },
      { title: 'Multilingual Support', desc: 'Fluent service in English and Russian' },
      { title: 'Local Expertise', desc: 'Deep knowledge of Saudi Arabia and its sacred sites' },
      { title: 'End-to-End Care', desc: 'From planning to return, we are with you every step' },
    ],
  },
  destinations: {
    label: 'DESTINATIONS',
    heading: 'Discover Saudi Arabia',
    places: ['Makkah', 'Madinah', 'AlUla', 'Riyadh', 'Jeddah', 'Red Sea'],
  },
  reviews: {
    label: 'WHAT OUR CLIENTS SAY',
    heading: 'Trusted by Travellers',
    googleCount: '20 reviews on Google',
    showAll: 'Show All Reviews',
    showLess: 'Show Less',
    items: [
      { name: 'Aman Satarov', time: '1 month ago', text: 'We used Kingdom Group services for our Umrah trip, and it was a truly pleasant experience from start to finish. Everything was well organized, smooth, and stress-free.' },
      { name: 'Mukhammad Khursanov', time: '1 month ago', text: 'Great service and comfortable luxury vehicles. All organized and hassle free! For sure will be using their service again InshaAllah!' },
      { name: 'Bilal Zubayrov', time: '3 weeks ago', text: 'Six of us used this service for the Medina–Mecca trip. The seating was comfortable, air-conditioned, and the stops were at the right places. Less expensive than a typical taxi, and more comfortable.' },
      { name: 'Azizjon Shamsiev', time: '1 year ago', text: "I recently had the pleasure of using Kingdom Group's services in Saudi Arabia, and I couldn't be more satisfied. His professionalism, dedication, and attention to detail truly set him apart." },
      { name: 'Alibek Akishev', time: '1 year ago', text: 'I want to recommend this company to everyone. Jamshed is an amazing brother. We booked an economy tour, but he gave us a full excursion around Medina. The emotions are beyond words.' },
      { name: 'SU NA', time: '1 year ago', text: 'My family and I had a very good experience with Kingdom Group. Professionals in their field, they met us very well and did their job perfectly. Very good cars. Highly recommend.' },
      { name: 'Sheikhislam Sakhi', time: '1 year ago', text: 'Best service, kind drivers that know several languages. They can even help you with various issues during your stay.' },
      { name: 'Dorush Rahimov', time: '1 year ago', text: 'I traveled with Kingdom Group from Makkah to Madinah. I really enjoyed it, it was comfortable and fast. I highly recommend everyone to use Kingdom Group services when they come to Saudi Arabia.' },
    ],
  },
  testimonials: {
    label: 'CLIENT TESTIMONIALS',
    heading: 'Hear From Our Travellers',
  },
  tiktok: {
    label: 'FOLLOW US ON TIKTOK',
    heading: 'Our Latest Videos',
    watch: 'Watch Video',
  },
  contact: {
    label: 'CONTACT',
    heading: 'Begin Your Journey',
    subtext: 'Tell us what you need. We will reply within 24 hours.',
    phone: 'Phone',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    email: 'Email',
    formTitle: 'Send Inquiry',
    nameLabel: 'Full Name',
    namePlaceholder: 'Your name',
    emailLabel: 'Email',
    emailPlaceholder: 'Your email',
    phoneLabel: 'Phone',
    phonePlaceholder: 'Your phone number',
    serviceLabel: 'Service Interest',
    servicePlaceholder: 'Select a service',
    serviceOptions: ['Umrah Guide', 'Individual Tour', 'Hotel Booking', '10-Year Saudi Visa', 'Other'],
    messageLabel: 'Message',
    messagePlaceholder: 'Your message',
    submit: 'Send Inquiry',
    sending: 'Sending…',
    successTitle: 'Message Sent!',
    successSubtitle: "We'll get back to you within 24 hours.",
    sendAnother: 'Send another message',
    errorMsg: 'Something went wrong. Please try again or contact us directly.',
  },
  footer: {
    tagline: 'Your Reliable Guide to Saudi Arabia',
    copyright: '© 2026 Kingdom Group. All rights reserved.',
  },
} as const;

export default en;
export type Translation = typeof en;
